import WDHQuiz from '../../wdh-quiz';
// eslint-disable-next-line no-unused-vars
import GTMTracking from '../../wdh-quiz/src/js/utils/gtm-tracking';
var hearingTest = new WDHQuiz();
hearingTest.run();